module.exports = "<transition name=\"fastBounce\">\n  <div v-if=\"checkSaved.save\" class=\"drzSaveAlert\">\n    <div>\n      <span class=\"drzSaveAlert-check\"></span>\n      <span class=\"drzSaveAlert-message\">{{ checkSaved.type }} Updated</span>\n    </div>\n  </div>\n</transition>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/page/save-alert/template.html
// module id = gxrT
// module chunks = 0